import React from 'react';
import JasonFile from "./formLangfields.json";
import { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import axios from "axios";
import useRecorder from "../utils/useRecorder.js";
import { useNavigate } from "react-router-dom";
import { Microphone, Stop, SignOut, Pause, ArrowClockwise, Record, CaretLeft, Check } from 'phosphor-react';
import { Form } from "react-bootstrap";
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"

export default function AddNewActPage() {
    const navigate = useNavigate();
    const [removeClick, setRemoveClick] = useState();
    const [selectLang, setLang] = useState();
    const [keywords, setKeywords] = useState([]);
    const [recorderName, setRecorderName] = useState();
    const [isLogin, setIsLogin] = useState(false);
    const [blurName, setBlurName] = useState(false);
    const [blurKeyword, setBlurKeyword] = useState(false);
    const [blurAct, setBlurAct] = useState([]);
    const [blurMeaning, setBlurMeaning] = useState([]);
    const [index, setIndex] = useState();
    const [Role, SetRole] = useState();
    const [usrID, SetUsrID] = useState();
    const [eve, SetEve] = useState();
    const [category, setCategory] = useState("Criminal law");
    const [act, setAct] = useState('');
    const [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();

    const [inputList, setinputList] = useState([{
        ["_id"]: "",
        act: "",
        meaning: ""
    }]);

    useEffect(() => {
        const lang = localStorage.getItem("legalLanguage");
        setLang(lang);
        let isLogin = localStorage.getItem("legalIsLogin");
        setIsLogin(isLogin);
        const token = localStorage.getItem("legaltoken");
        if (token) {
            const usrRole = jwt_decode(token).role
            const usrID = jwt_decode(token).user_id
            SetRole(usrRole);
            SetUsrID(usrID)
        }
        else {
            navigate('/lawdictionary/login')
        }
    }, []);

    // Voice to Text for Speaker Function //
    React.useEffect(() => {
        const fetchText = async () => {
            let fileName = `aud.wav`;
            let fd = new FormData();
            const output = await axios({ method: "get", url: audioURL, responseType: "blob" });
            let files = new File([output.data], fileName, { type: "audio/wav" });
            fd.append("file", files);
            fd.append("language", selectLang);
            axios.post("https://voiceapi.aicte-india.org/voice-to-text", fd)
                .then(async (res) => {
                    const textResponse = res.data;
                    let NewData = { ...inputList }
                    if (recorderName == "meaning") {
                        let temp = eve;
                        temp.target.value = textResponse.data;
                        temp.target.name = 'meaning'
                        HandleChange(temp, index)
                        HandleBlurCheck(index, recorderName)
                    }
                    if (recorderName == "keyword") {
                        let key = textResponse.data;
                        setKeywords([...keywords, key])
                    }
                    if (recorderName == 'Name') {
                        setAct(textResponse.data)
                        setBlurName(true)
                    }
                });
        };
        if (audioURL !== undefined) {
            fetchText();
        }
    }, [audioURL]);
    // Voice to Text for Speaker Function //

    const HandleChange = (e, i) => {
        let variable = e.target.name;
        let value = e.target.value;
        let items = [...inputList];
        items[i][variable] = value;
        setinputList(items);
    };

    const handleremove = (index) => {
        const list = [...inputList];
        list.splice(index, 1);
        setinputList(list);
    };

    const handleaddclick = () => {
        setinputList([
            ...inputList,
            {
                ["_id"]: "",
                act: "",
                meaning: ""
            },
        ]);
        setBlurAct([...blurAct, false])
        setBlurMeaning([...blurMeaning, false])
    };

    const handleKeyPress = (e) => {
        if (e.key == 'Enter') {
            setKeywords([...keywords, e.target.value])
        }
    }

    const removeKeyword = (ind) => {
        let temp = [...keywords]
        temp.splice(ind, 1)
        setKeywords(temp)
    }

    useEffect(() => {
        removeKeyword(removeClick)
    }, [removeClick])

    const submitRecord = () => {
        if (inputList[0].act === '' || act === "" || inputList[0].meaning === '') {
            alert("All fields required")
        } else {
            const post = {
                Act: inputList,
                category: category,
                original_language: selectLang,
                word: act,
                keyword: keywords
            };
            axios.post(process.env.REACT_APP_BASE_URL + 'addNewAct', post, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
                },
            })
                .then(res => {
                    const resID = res.data.response;
                    if (Role == 'admin' || Role == 'validator') {
                        alert('Thank you for  submission');
                        navigate("/lawdictionary/list");
                    }
                    else {
                        const postData = {
                            user_id: usrID,
                            language: selectLang,
                            act_id: resID
                        }
                        axios.post(process.env.REACT_APP_BASE_URL + 'verify/submitRequest', postData, {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
                            },
                        })
                            .then(res => {
                                alert('Thank you, Your data entry has been submitted for the approval')
                                navigate("/lawdictionary/user-request-list");
                            })
                            .catch(err => { console.log(err) })
                    }

                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    // Login and Logout Function //
    const handleLogout = () => {
        localStorage.setItem("legalIsLogin", false);
        localStorage.removeItem("legaltoken");
        navigate("/lawdictionary");
    };
    const handleLogin = () => {
        navigate("/lawdictionary/login");
    };
    // Login and Logout Function //

    const HandleBlurCheck = (i, field) => {
        if (field == 'act') {
            let temp = blurAct;
            temp[i] = true;
            setBlurAct(temp);
        } else {
            let temp = blurMeaning;
            temp[i] = true;
            setBlurMeaning(temp);
        }
    };

    return (
        <>
            <div className="topDivLogin searchList ">
                <header className="headerLst">
                    <div className="container mainSrchDiv">
                        <div className="mainSrchDivIn">
                            <div className="row align-items-center">
                                <div className="logoarea col-12 col-sm-12 col-md-12 col-lg-9">
                                    <div className="d-flex justify-content-start flex-wrap align-items-center">
                                        <div className="listLogo">
                                            <a href="https://anuvadini.aicte-india.org/">
                                                <img src={anu_logo} width="210px" />
                                            </a>
                                            <a>
                                                <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                                            </a>
                                            <a href="">
                                                <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                                    <div className="d-flex justify-content-end align-items-center phonecenter">
                                        <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                                            Home
                                        </button>
                                        {isLogin == "true" ? (
                                            <>
                                                <div className="d-flex justify-content-end buttonmargin">
                                                    <div className="wrapper signout">
                                                        <button className="button w-auto" onClick={() => handleLogout()}><b><SignOut size={32} /></b>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>) : (<>
                                                <div className="wrapper">
                                                    <button className="button w-auto" onClick={() => handleLogin()} > <b>Login</b></button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </header>

            </div>
            <div className='clearfix'></div>
            <div className="container">
                <div className="feedbackform newact">
                    <p style={{ color: 'blue', textDecoration: "underline", marginTop: 20, }} onClick={() => { navigate('/lawdictionary/list') }}><CaretLeft size={20} /> Back</p>
                    <div className='row'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
                            <label>Select Language</label>
                            <Dropdown className="text-start w-100 form-control">
                                <Dropdown.Toggle className="selectmenu text-start p-relative w-100" variant="default" >
                                    {selectLang ? JasonFile[0][selectLang] : "Select Language"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {Object.entries(JasonFile[0]).map((res, i) => {
                                        return (
                                            <Dropdown.Item value={res[0]} onClick={(e) => setLang(res[0])} key={i} >
                                                {res[1]}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
                            <label>Select Category</label>
                            <Form.Select aria-label="Default select example" className='form-control' onChange={(e) => { setCategory(e.target.value) }}>
                                <option value="Criminal law" onClick={(e) => { setCategory(e.target.value) }}>Criminal law</option>
                                <option value="Civil law" onClick={(e) => { setCategory(e.target.value) }}>Civil law</option>
                                <option value="Common law or case law or Judicial precedent or judge-made law" onClick={(e) => { setCategory(e.target.value) }}>Common law or case law or Judicial precedent or judge-made law</option>
                                <option value="Statutory law" onClick={(e) => { setCategory(e.target.value) }}>Statutory law</option>
                            </Form.Select>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-3 position-r">
                            <label>Name (Example - Act Name, Skill, Education)</label>
                            <input type="text" name="searchQuery" className="form-control" value={act} onChange={(e) => { setAct(e.target.value); setBlurName(true) }} />
                            {selectLang === "or-IN" || selectLang === "as-IN" || selectLang === "pa-IN" ? <></> : <>
                                <div className='fromGroup schema quill'>
                                    {isRecording && recorderName == 'Name' ?
                                        <React.Fragment>
                                            <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                                                <Stop size={32} weight="fill" />
                                            </button>
                                            {pause != false ?
                                                <>
                                                    <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                                                    <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                                                </>
                                                :
                                                <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                                                    {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                                                </>
                                            }
                                        </React.Fragment>
                                        :
                                        <button className="startbutton" onClick={e => { setRecorderName('Name'); startRecording(); }} disabled={isRecording}>
                                            <Microphone size={20} weight="fill" />
                                        </button>
                                    }
                                </div>
                            </>}
                            {Role != "user" && blurName == true ? <>
                                <div className='check'>
                                    <Check size={25} color="#2fd824" weight="light" />
                                </div>
                            </> : ""}
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-3 position-r">
                            <label>Keyword</label>
                            <Form.Control type="text" name="keyword" className="form-control" onKeyDown={(e) => { (handleKeyPress(e)); setBlurKeyword(true) }} />
                            {selectLang === "or-IN" || selectLang === "as-IN" || selectLang === "pa-IN" ? <></> : <>
                                <div className='fromGroup schema quill'>
                                    {isRecording && recorderName == 'keyword' ?
                                        <React.Fragment>
                                            <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                                                <Stop size={32} weight="fill" />
                                            </button>
                                            {pause != false ?
                                                <>
                                                    <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                                                    <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                                                </>
                                                :
                                                <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                                                    {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                                                </>
                                            }
                                        </React.Fragment>
                                        :
                                        <button className="startbutton" onClick={e => { setRecorderName('keyword'); startRecording(); }} disabled={isRecording}>
                                            <Microphone size={20} weight="fill" />
                                        </button>
                                    }
                                </div>
                            </>}
                            {Role != "user" && blurKeyword == true ? <>
                                <div className='check'>
                                    <Check size={25} color="#2fd824" weight="light" />
                                </div>
                            </> : ""}
                            <div className='removetext'>
                                {keywords?.map((it, ind) => (
                                    <>
                                        <p>{it} <span onClick={() => { setRemoveClick(ind) }}>X</span></p>
                                        {/* </div> */}
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>

                    {inputList?.map((x, i) => {
                        return (
                            <>
                                <ul className="row job-supplement-attributes">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
                                        <label>ID (Example Act ID)</label>
                                        <Form.Control type="text" name="act" className="form-control" value={x.act} onChange={(e) => { HandleChange(e, i); HandleBlurCheck(i, 'act') }} />
                                        {Role != "user" && blurAct[i] == true ? <>
                                            <div className='check'>
                                                <Check size={25} color="#2fd824" weight="light" />
                                            </div>
                                        </> : ""}
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
                                        <label>Meaning / Defination</label>
                                        <Form.Control as="textarea" rows={8} className="textarea" name="meaning" value={x.meaning} onChange={(e) => { HandleChange(e, i); HandleBlurCheck(i, 'meaning') }} />
                                        {selectLang === "or-IN" || selectLang === "as-IN" || selectLang === "pa-IN" ? <></> : <>
                                            <div className='fromGroup'>
                                                {isRecording && recorderName == 'meaning' ?
                                                    <React.Fragment>
                                                        <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                                                            <Stop size={32} weight="fill" />
                                                        </button>
                                                        {pause != false ?
                                                            <>
                                                                <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                                                                <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                                                            </>
                                                            :
                                                            <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                                                                {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                                                            </>
                                                        }
                                                    </React.Fragment>
                                                    :
                                                    <button className="startbutton" onClick={e => { SetEve(e); setIndex(i); setRecorderName('meaning'); startRecording(); }} disabled={isRecording}>
                                                        <Microphone size={20} weight="fill" />
                                                    </button>
                                                }
                                            </div>
                                        </>}
                                        {Role != "user" && blurMeaning[i] == true ? <>
                                            <div className='check'>
                                                <Check size={25} color="#2fd824" weight="light" />
                                            </div>
                                        </> : ""}
                                    </div>
                                </ul>

                                <div className="d-flex justify-content-end addlistul">
                                    {inputList.length - 1 == i && (
                                        <button className="btn btn-primary" onClick={handleaddclick}>
                                            <i className="fa fa-plus"></i> Add
                                        </button>
                                    )}
                                    {inputList.length !== 1 && i > 0 && (
                                        <button className="btn btn-danger ml-3" onClick={() => handleremove(i)}>
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    )}
                                </div>
                            </>
                        );
                    })}

                </div>
                <div className="text-center d-flex justify-content-center mb-5">
                    <button type="button" onClick={() => { submitRecord() }} className="feedbackSpn h-auto w-auto btn btn-success p-3 btn-lg" >
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}